// As treze abas, na ordem em que aparecem no painel atual (index.html:570-582).
//
// A ordem é a definição: as setas do teclado andam por esta lista, e o `/p/:slug`
// sem aba cai na primeira. `somenteAdmin` substitui a classe `.admin-only` que o
// startApp() ligava e desligava à mão.
export interface Aba {
  id: string;
  rotulo: string;
  /** Tem contador na aba? Qual, cada tela decide; aqui só se ele existe. */
  contador?: boolean;
  somenteAdmin?: boolean;
}

export const ABAS: readonly Aba[] = [
  { id: 'overview', rotulo: 'Overview' },
  { id: 'doc', rotulo: 'Documentação' },
  { id: 'graph', rotulo: 'Grafo', contador: true },
  { id: 'search', rotulo: 'Busca' },
  { id: 'notes', rotulo: 'Notas', contador: true },
  { id: 'sessions', rotulo: 'Sessões', contador: true },
  { id: 'review', rotulo: 'Revisão', contador: true },
  { id: 'decisions', rotulo: 'Decisões', contador: true },
  { id: 'impact', rotulo: 'Impacto' },
  { id: 'health', rotulo: 'Saúde', contador: true },
  { id: 'commits', rotulo: 'Rastreabilidade' },
  { id: 'admin', rotulo: 'Projetos', somenteAdmin: true },
  { id: 'users', rotulo: 'Usuários', somenteAdmin: true },
] as const;

export const abasVisiveis = (admin: boolean): Aba[] =>
  ABAS.filter((a) => admin || !a.somenteAdmin);

export const abaExiste = (id: string, admin: boolean): boolean =>
  abasVisiveis(admin).some((a) => a.id === id);

export const ABA_PADRAO = ABAS[0].id;

/**
 * Para onde o foco vai com seta, Home e End numa tablist (WAI-ARIA).
 * Separado do componente porque é a única parte com regra: a lista circula, e
 * quem está na última aba vai para a primeira com ArrowRight.
 */
export function proximaAba(abas: Aba[], atual: number, tecla: string): number | null {
  if (atual < 0) return null;
  switch (tecla) {
    case 'Home': return 0;
    case 'End': return abas.length - 1;
    case 'ArrowRight': return (atual + 1) % abas.length;
    case 'ArrowLeft': return (atual - 1 + abas.length) % abas.length;
    default: return null;
  }
}
